import eCreditFetch from './acc_interceptor.ts';
import ServiceResponse from "@/types_and_interfaces/service_response_interface.ts";
import API_CLS from "@/utils/api.ts";
import * as Sentry from "@sentry/react";

export const get_per_pages_notification = async (per_page:number) => {
    let response:ServiceResponse = {
        error: false,
    };
    
    
    try {
        const request = await eCreditFetch(`${API_CLS.notifications.get_per_pages}/${per_page}`, {
            method: API_CLS.methods.Get,
        });
        
        response.status = request?.status
        const body = await request?.json();
        
        
        if(response.status === 200 && request) {
            response.message = "ok"
            response.response = body?.data
        } else {
            response.error = true
        }
        
        return response;
        
    } catch (error) {
        Sentry.captureException(error, { tags: { section: "notifications", action: "get_per_pages" } });
        response.error = true;

        return response;
    }
}

export const read_all_notification = async () => {
    let response:ServiceResponse = {
        error: false,
    };
    
    
    try {
        const request = await eCreditFetch(API_CLS.notifications.read_all, {
            method: API_CLS.methods.Post,
        });
        
        response.status = request?.status
        const body = await request?.json();
        
        if(response.status === 200) {
            response.message = "ok"
            response.response = body?.data
            
        } else {
            response.error = true
        }
        
        return response;
        
    } catch (error) {
        Sentry.captureException(error, { tags: { section: "notifications", action: "read_all" } });
        response.error = true;

        return response;
    }
}

export const get_notif_count = async () => {
    let response:ServiceResponse = {
        error: false,
    };
    
    
    try {
        
        const request = await eCreditFetch(API_CLS.notifications.get_counter, {
            method: API_CLS.methods.Get,
        });
        
        response.status = request?.status
        const body = await request?.json();
        
        if(response.status === 200) {
            response.message = "ok"
            response.response = body?.data
            
        } else {
            response.error = true
        }
        
        return response;
        
    } catch (error) {
        Sentry.captureException(error, { tags: { section: "notifications", action: "get_count" } });
        response.error = true;

        return response;
    }
}

export const generte_notification = async () => {
    let response:ServiceResponse = {
        error: false,
    };
    
    
    try {
        const request = await eCreditFetch(API_CLS.notifications.generate, {
            method: API_CLS.methods.Post,
        });
        
        response.status = request?.status
        
        if(response.status === 200) {
            response.message = "ok"
            
        } else {
            response.error = true
        }
        
        return response;
        
    } catch (error) {
        Sentry.captureException(error, { tags: { section: "notifications", action: "generate" } });
        response.error = true;

        return response;
    }
}

export const delete_notifications = async (notification_id:string) => {
    let response:ServiceResponse = {
        error: false,
    };
    
    const data = {"notification_id": notification_id}
    try {
        const request = await eCreditFetch(API_CLS.notifications.delete, {
            method: API_CLS.methods.Post,
            body: JSON.stringify(data)
        });
        
        response.status = request?.status
        // const body = await request?.json();
        
        if(response.status === 200) {
            response.message = "ok"
            
        } else {
            response.error = true
        }
        
        return response;
        
    } catch (error) {
        Sentry.captureException(error, { tags: { section: "notifications", action: "delete" } });
        response.error = true;

        return response;
    }
}



export const notif_register = async (data:any) => {
    let response:ServiceResponse = {
        error: false,
    };
    
    try {
        const request = await eCreditFetch(API_CLS.notifications.notif_register, {
            method: API_CLS.methods.Post,
            body: JSON.stringify(data)
        });
        
        response.status = request?.status
        
        const body = await request?.json();
        
        if(response.status === 200) {
            response.message = "ok"
            response.response = body
            
        } else {
            response.error = true
        }
        
        return response;
        
    } catch (error) {
        Sentry.captureException(error, { tags: { section: "notifications", action: "register_device" } });
        response.error = true;

        return response;
    }
}

export const get_technical = async () => {
    let response:ServiceResponse = {
        error: false,
    };
    
    try {
        const request = await eCreditFetch(API_CLS.notifications.get_technical, {
            method: API_CLS.methods.Get,
        });
        
        response.status = request?.status
        
        const body = await request?.json();
        
        if(response.status === 200) {
            response.message = "ok"
            response.response = body
            
        } else {
            response.error = true
        }
        
        return response;
        
    } catch (error) {
        Sentry.captureException(error, { tags: { section: "notifications", action: "get_technical" } });
        response.error = true;

        return response;
    }
}